module.exports = __webpack_public_path__ + "img/shape-color-toy-1.jpg";